 <template>
  <div>
    <v-dialog v-model="sign_off_report" max-width="1000" persistent>
      <v-card :loading="loading" class="sales-invoice-report">
        <v-card-text class="pt-3">
          <v-row dense>
            <v-col cols="12" style="font-size: 18px;" class="text-center">
              <b>View/Edit</b>
              <v-divider class="mt-3 mb-3"></v-divider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="4">
              <v-row dense="">
                <v-col cols="3" style="max-width: 22%;">
                  <v-img :src="company_details.logo_path" width="60"></v-img>
                </v-col>
                <v-col class="license-number" style="line-height: 18px;">
                  <div style="font-size: 16px;">{{company_details.name}}</div>
                  <div class="ml-2">{{ company_details.license_number}}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <div class="ml-2" style="font-size: 18px;">
                <!-- <i><b>Since {{ company_details.company_start_year}}</b></i> -->
                </div>
            </v-col>
            <v-col cols="4" class="text-right">
              Tel : <b>{{ company_details.phone_number}}</b><br>
              <a :href="company_details.website_link" target="_blank">
                {{ company_details.website_link}}
              </a>
            </v-col>
          </v-row>
          <v-row dense="">
            <v-col cols="6">
              {{company_details.shipping_address_line_1}}, {{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}
            </v-col>
            <v-col cols="6" class="text-right">
              {{company_details.email+'@'+company_details.domain_details.domain}}
            </v-col>
          </v-row>
          <v-row dense="">
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border ">
                <tbody>
                  <tr class="grey lighten-2">
                    <td><i>Our Goal 100% Customer Satisfaction</i></td>
                    <td style="font-size: 18px;" class="text-center">Sign Off : {{company_details.company_id+'-'+project_details.project_id}}</td>
                    <td class="text-center">{{project_details.display_date}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row dense="">
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Billing</td>
                    <td width="30%">{{project_details.bill_to}}</td>
                    <td width="20%" class="grey lighten-2">Shipping</td>
                    <td width="30%">{{(project_details.customer)?project_details.customer.full_name:''}}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">{{project_details.mobile}}</td>
                    <td width="30%">{{project_details.bill_to_address_1}}</td>
                    <td width="20%" class="grey lighten-2">{{project_details.mobile}}</td>
                    <td width="30%">{{project_details.p_address_1}}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2"></td>
                    <td width="30%">{{(project_details.bill_to_city_details)?project_details.bill_to_city_details.city_name+',':''}} {{(project_details.bill_to_state_details)?project_details.bill_to_state_details.short_name:''}} {{project_details.bill_to_zip}}</td>
                    <td width="20%" class="grey lighten-2"></td>
                    <td width="30%">{{(project_details.city_details)?project_details.city_details.city_name+',':''}} {{(project_details.state_details)?project_details.state_details.short_name:''}} {{project_details.p_zip}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row dense="" class="mt-2">
            <v-col>
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr v-for="(row, index) in items" :key="index">
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 1)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 1)?'white--text':''" @click="row.answer = 1;">
                        Yes
                      </v-btn>
                    </td>
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 2)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 2)?'white--text':''" @click="row.answer = 2;">
                        No
                      </v-btn>
                    </td>
                    <td width="7%" class="pa-1">
                      <v-btn block :color="(row.answer == 3)?'blue-grey darken-2':'grey'" class="text-capitalize rounded-0" :class="(row.answer == 3)?'white--text':''" @click="row.answer = 3;">
                        N/A
                      </v-btn>
                    </td>
                    <td>
                      {{replace_text(row.text)}}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="1" style="max-width: 3%;" class="d-flex">
              <span class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openSignOffQueDialog();"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>

          <v-row dense="" class="mt-10">
            <v-col cols="5" class="text-center">
              <br>
              <v-divider></v-divider>
              {{project_details.bill_to}}
            </v-col>
            <v-col cols="2">
            </v-col>
            <v-col cols="5" class="text-center">
              We Thank you for doing Business with {{company_details.name}}
              <v-divider></v-divider>
              {{user_name}}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading" @click="generateSignOffReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Save
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateSignOffReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Sign Off Question</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-text-field
                label="Text*"
                v-model="form_data.text"
                :error-messages="form_error.text"
                :hide-details="!form_error.text"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addSignOff"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe
                :src="preview_page_link"
                frameborder="0"
                style="width:100%;height:800px"
              ></iframe>
              <!-- <iframe
                :src="'https://docs.google.com/gview?embedded=true&url='+preview_page_link"
                frameborder="0"
                style="width:100%;height:800px"
              ></iframe> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0; note = '';">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="signature_dialog = true;"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>  
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sign_off_que_dialog" max-width="710" persistent>
      <v-card :loading="edit_sign_off_loading">
        <v-row dense="" class="pa-0 ma-0">
          <v-col cols="6">
            <v-card-title class="headline">Add/Edit Sign Off Questions</v-card-title>
          </v-col>
          <v-col cols="6" class="d-flex align-self-center">
            <span style="font-weight: 401;" class="mr-1">Short code for dynamic value:</span> {company_name}
          </v-col>
        </v-row>
        <v-card-text>
          <v-row dense="" class="mb-0">
            <v-col cols="12">
              <v-row dense="" class="grey lighten-2">
                <v-col>
                  Text
                </v-col>
                <v-col cols="1" style="max-width: 5%;">
                  <v-icon @click="addRemoveEntry('yes')">mdi-plus-circle</v-icon>
                </v-col>
              </v-row>
              <v-row dense v-for="(row2, index) in edit_items" :key="index" >
                <v-col>
                  <v-text-field
                    dense
                    v-model="row2.text"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="1" style="max-width: 5%;">
                  <v-icon @click="addRemoveEntry('no',index)">mdi-close-circle</v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="sign_off_que_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            :loading="edit_sign_off_loading"
            @click="updateSignOff('no')"
          >Update for this project</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            :loading="edit_sign_off_loading"
            @click="updateSignOff('yes')"
          >Update Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog :email_id="email_ids" :email_dialog="email_dialog" @closeDialog="closeSendMailDialog" @sendMail="sendMail" />
    <Signatura :customer_sign="customer_sign_blob" :active_page="active_page" displayNote="true" @updateValue="updateParent" @clearValue="clearParent" :project_details="project_details" :signature_dialog="signature_dialog" />
  </div>
 </template>
 <script>
 import axios from "../../plugins/axios";
 import { getCompanyDetails } from "../../plugins/helper";
 import SendMailDialog from "../projects/SendMailDialog";
 import Signatura from "../projects/Signatura";
 import { mapMutations } from "vuex";
 export default {
   data() {
     return {
       email_id_arr: [],
      preview_pdf_loading: '',
      total_page: '',
      active_page: 0,
      preview_pdf_dialog: false,
      preview_page_link: '',
      user_sign_blob: [],
      customer_sign_blob: '',
      signature_dialog: false,
      is_send_report: false,
      dialog: false,
      edit_sign_off_loading: false,
      form_data: {},
      form_error: {},
      edit_form_data: {},
      edit_form_error: {},
      edit_items: [],
      form_loading:false,
      sign_off_qs_id: null,
      sign_off_que_dialog: false,
      items: [],
      loading: false,
      email_ids: null,
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      note: '',
      company_details: getCompanyDetails(),
     }
   },
   props: ['sign_off_report','project_details','sign_off_for'],
   watch: {
     sign_off_report: function(value) {
      if (value) {
        this.preview_page_link = '';
        this.active_page = 0;
        this.user_sign_blob = []; 
        this.customer_sign_blob = '';
        this.note = '';
        this.getSignOff();
        this.getTotalPage();
      }
    }
   },
   computed: {
     user_name() {
       return localStorage.getItem('user_name');
     }
   },
   components: {
     Signatura,
      SendMailDialog
   },
   methods: {
      ...mapMutations("utils", ["setAlert"]),
      sendMail(variable) {
        this.email_id_arr = variable
        this.sendSignOffReport();
      },
      closeSendMailDialog() {
        this.email_dialog = false; 
        this.preview_pdf_dialog = false; 
        this.user_sign_blob = []; 
        this.customer_sign_blob = ''; 
        this.active_page = 0;
        this.note = ''
      },
      updateParent(variable) {
        if(variable.user_sign_blob) {
          this.user_sign_blob[this.active_page] = variable.user_sign_blob;
        }
        if(variable.customer_sign_blob && this.active_page == 1) {
          this.customer_sign_blob = variable.customer_sign_blob;
        }
        this.note = variable.note
        this.signature_dialog = false
        if(this.is_send_report) {
          if(this.total_page == this.active_page) {
            this.email_dialog = true; 
            this.email_ids = this.project_details.customer.email+'@'+this.project_details.customer.email_domain.domain;
          } else {
            this.generateSalesInvoiceReport(false);
          }
        } else {
          if(this.total_page == this.active_page) {
            this.generateSignOffReport(true);
          } else {
            this.generateSignOffReport(false);
          }
        }
      },
      clearParent(variable) {
        console.log(variable)
        this.note = variable.note
        this.signature_dialog = false
      },
      replace_text(text) {
        return text.replace("{company_name}", this.company_details.name);
      },
      addRemoveEntry(is_add,index) {
        if(is_add == 'no') {
          this.edit_items.splice(index, 1);
        } else {
          this.edit_items.push({
            text: ''
          })
        }
      },
      openSignOffQueDialog() {
        this.edit_items = JSON.parse(JSON.stringify(this.items));
        this.sign_off_que_dialog = true
      },
      addSignOff() {
        let _self = this;
        _self.form_loading = true;
        axios.post("add_sign_off", _self.form_data)
          .then((response) => {
            _self.form_data = {};
            _self.form_error = {};
            let data = response.data;
            if (!data.status) {
              _self.form_loading = false;
              for (let key in data.errors) {
                _self.form_error[key] = data.errors[key][0];
              }
            } else {
              _self.form_loading = false;
              _self.dialog = false
              _self.getSignOff()
              _self.getTotalPage();
            }
          })
          .catch(function () {
            _self.form_loading = false;
          });
      },
      updateSignOff(update_for_all_project){
        let _self = this;
        this.edit_sign_off_loading = true;
        let form_date = {
          questions: this.edit_items,
          sign_off_for: this.sign_off_for,
          update_for_all_project: update_for_all_project,
          project_id: this.project_details.project_id
        }
        axios.post("update_sign_off", form_date)
          .then(() => {
            _self.edit_sign_off_loading = false;
            _self.sign_off_que_dialog = false;
            _self.getSignOff();
            _self.getTotalPage();
          })
          .catch(function () {
            _self.edit_sign_off_loading = false;
          });
      },
      closePopup() {
        this.$emit('updateValue');
      },
      getSignOff() {
        let _self = this;
        this.loading = true;
        axios
        .get("sign_off_list?sign_off_for="+this.sign_off_for+'&project_id='+this.project_details.project_id)
        .then(response => {
          let response_data = response.data;
          _self.items = JSON.parse(JSON.stringify(response_data.data));
          _self.edit_items = JSON.parse(JSON.stringify(response_data.data));
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
      },
      getTotalPage() {
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        let data = {
          project_id: this.project_details.project_id,
          items: this.items,
          user_name: localStorage.getItem('user_id'),
          company_id: company_data.company_id,
          note: this.note,
          generate_pdf_flag: 'get_total'
        }
        this.loading = true;
        axios
        .post("generate_sign_off_pdf",data)
        .then(response => {
          if(response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });  
      },
      generateSignOffReport(is_past_page) {
        this.active_page++;
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        let data = {
          flag: 'save',
          project_id: this.project_details.project_id,
          items: this.items,
          user_name: localStorage.getItem('user_id'),
          company_id: company_data.company_id,
          note: this.note,
          active_page: this.active_page,
          total_page: this.total_page
        }
        if(is_past_page) {
          if(this.user_sign_blob) {
            data.user_sign_blob = this.user_sign_blob
          }
          if(this.customer_sign_blob) {
            data.customer_sign_blob = this.customer_sign_blob
          }
          data.generate_pdf_flag = 'whole_page'
        } else {
          data.generate_pdf_flag = 'single_page'
        }
        this.preview_pdf_loading = true;
        axios
        .post("generate_sign_off_pdf",data)
        .then(response => {
          if(is_past_page) {
            if(response.data.status) {
              this.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0
              });
              this.preview_pdf_dialog = false;
              this.closePopup();
            }
          } else {
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false
        }); 
      },
      sendSignOffReport() {
        let company_data = localStorage.getItem('company_data')
        company_data = JSON.parse(company_data)
        let data = {
          flag: 'mail',
          project_id: this.project_details.project_id,
          items: this.items,
          user_name: localStorage.getItem('user_id'),
          company_id: company_data.company_id,
          note: this.note,
          active_page: this.active_page,
          total_page: this.total_page,
          email_ids: this.email_ids,
          email_id_arr: this.email_id_arr
        }
        if(this.user_sign_blob) {
          data.user_sign_blob = this.user_sign_blob
        }
        if(this.customer_sign_blob) {
          data.customer_sign_blob = this.customer_sign_blob
        }
        data.generate_pdf_flag = 'whole_page'
        this.send_pdf_loading = true;
        axios
        .post("generate_sign_off_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if(response.data.status) {
            this.email_dialog = false
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
              this.email_ids_error = response.data.errors['email_ids'];
          }
          this.send_pdf_loading = false
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false
        });        
      },
    },
    created: function() {
    },
    mounted: function () {
    }
 }
 </script>